import 'swiper/css';
import classNames from 'classnames';
import { Link } from 'gatsby';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import NavLeftButton from '_components/article-v3/NavLeftButton';
import NavRightButton from '_components/article-v3/NavRightButton';
import Tag from '_components/tag';
import { urlForArticle } from '_utils/articles';
import { urlFor } from '_utils/images';

export default function SimilarCategoryCars({ articles, className }) {
  const swiperRef = React.useRef();

  const navLeft = React.useCallback(() => {
    swiperRef.current?.swiper.slidePrev();
  }, []);

  const navRight = React.useCallback(() => {
    swiperRef.current?.swiper.slideNext();
  }, []);

  const slidesPerView = React.useMemo(() => {
    if (typeof window === 'undefined') {
      return 3;
    }
    return window.innerWidth > 1024 ? 3 : 2;
  }, []);

  return (
    <div className={classNames('text-content-primary', className)}>
      <div className="text-lg sm:text-2xl font-bold text-content-primary md:mb-4 lg:mb-0">
        Similar Category Cars
      </div>
      <div className="hidden sm:block mt-8 relative">
        <NavLeftButton onClick={navLeft} />
        <NavRightButton onClick={navRight} />
        <Swiper
          ref={swiperRef}
          slidesPerView={slidesPerView}
          spaceBetween={16}
          loop
        >
          {articles.map((a) => (
            <SwiperSlide key={a._id}>
              <Link
                key={a._id}
                className="py-4 md:py-0 md:px-4 lg:px-0 lg:py-4 text-content-primary hover:text-content-primary"
                to={urlForArticle(a)}
              >
                <div className="w-full pt-[56.25%] relative">
                  <div className="absolute inset-0">
                    <img
                      src={urlFor(a.thumbnail).width(500).format('webp').url()}
                      alt={a.title}
                      className="w-full h-full object-cover object-right-bottom rounded-lg"
                    />
                  </div>
                </div>
                <div className="font-bold line-clamp-2 mt-4">{a.title}</div>
                <div className="mt-1 line-clamp-3">{a.excerpt}</div>
                <div className="mt-2 flex gap-x-1">
                  {a.tags_v3?.map((tag, index) => (
                    <Tag key={index}>{tag.name}</Tag>
                  ))}
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="mt-3 sm:hidden md:mt-8 flex flex-col gap-y-4">
        {articles.map((a) => (
          <Link
            key={a._id}
            className="text-content-primary hover:text-content-primary flex gap-x-3"
            to={urlForArticle(a)}
          >
            <div className="w-24 h-24 relative flex-shrink-0">
              <div className="absolute inset-0">
                <img
                  src={urlFor(a.thumbnail).width(500).format('webp').url()}
                  alt={a.title}
                  className="w-full h-full object-cover object-right-bottom rounded-lg"
                />
              </div>
            </div>
            <div className="mt-2">
              <div className="font-bold line-clamp-2 mt-4">{a.title}</div>
              <div className="mt-2 flex gap-x-1">
                {a.tags_v3?.map((tag, index) => (
                  <Tag key={index}>{tag.name}</Tag>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
